<template>
  <div class="paramset">
    <el-form
      v-if="status == 2"
      :model="setForm"
      ref="setForm"
      class="paramsForm"
      :rules="formRules"
      :label-width="220"
    >
      <el-form-item label="A相集乳器端修正值" prop="adiff">
        <el-row :style="{ width: '100%' }">
          <el-col :span="5">
            <Keyboard v-model="setForm.adiff">
              <el-input v-model="setForm.adiff"></el-input>
            </Keyboard>
          </el-col>
          <el-col :span="19">
            <div class="form-msg"></div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="C相集乳器端修正值" prop="cdiff">
        <el-row :style="{ width: '100%' }">
          <el-col :span="5">
            <Keyboard v-model="setForm.cdiff">
              <el-input v-model="setForm.cdiff"></el-input>
            </Keyboard>
          </el-col>
          <el-col :span="19">
            <div class="form-msg"></div>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- <div class="sunBox">
        <el-form-item label="&nbsp;">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
      </div> -->
    </el-form>
    <div class="subBox">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { send } from ".././../socket/index";
import Keyboard from "@/components/keyboard/index.vue";

export default {
  name: "Page",
  components: { Keyboard },
  data() {
    return {
      status: 0,
      setForm: {},
      formRules: {
        adiff: [{ required: true, message: "必填" }],
        cdiff: [{ required: true, message: "必填" }],
      },
    };
  },
  methods: {
    async submit() {
      try {
        let valRes = await this.$refs.setForm.validate();
        console.log(valRes);
      } catch (err) {
        console.log("err");
        console.log(err);
        return;
      }

      try {
        let res = await this.$myRequest({
          url: "/saveAdjustingValuesReq",
          method: "post",
          data: this.setForm,
        });
        res = res.data;
        this.init();
      } catch (err) {
        console.log(err);
      }
    },
    async init() {
      try {
        let res = await this.$myRequest({
          url: "/getAdjustingValuesReq",
          method: "post",
        });
        res = res.data;
        this.setForm = res.data;
        this.status = 2;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.init();

    this.$store.commit("checkTick");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
